import * as React from 'react';

/**
 * Set the title of the page, using the method provided
 * by the context
 */
export const useTitle = (title: string) => {
  React.useEffect(() => {
    const originalTitle = document.title;
    document.title = `${title} | Matchhaus`;
    // when unmounting, restore the previous title
    return () => {
      document.title = originalTitle;
    };
  }, [title]);
};
